<template>
  <div
    v-if="isVisible"
    class="alert inline alert-warning awaiting-payment-notice"
    role="alert"
    data-testid="awaiting-payment-notice"
  >
    <button
      type="button"
      class="close"
      aria-label="Dismiss"
      data-testid="awaiting-payment-dismiss"
      @click="dismiss"
    >
      &times;
    </button>
    <ul class="awaiting-payment-notice__orders">
      <li
        v-for="order in orders"
        :key="order.id"
        :data-testid="`awaiting-payment-order-${order.id}`"
      >
        <span v-if="order.status === PAYMENT_FAILED_STATUS">
          Your payment for order #{{ order.id }} didn't go through. Pay your
          balance to get started.
        </span>
        <span v-else>
          Order #{{ order.id }} has an unpaid balance. Pay your balance to get
          started.
        </span>
        <a
          :href="order.url"
          class="btn btn-dc btn-sm"
          :data-testid="`awaiting-payment-pay-${order.id}`"
        >
          Pay Balance
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
const PAYMENT_FAILED_STATUS = "PAYMENT_FAILED";

// Module scope, not component data: a dismissal has to survive leaving and
// returning to the dashboard, and resets on the next page load (i.e. the next login).
let dismissedThisSession = false; // DS-PORT-DEFECT (drivescout-vue3 M4 slice 3, 2026-10-07): row P-banner-dismiss-session: logout and login are state changes, not page loads (drivecoach.run.ts:250-252, login-service.ts:82), so this flag survives a sign-out and a sign-in in the same tab, and a student who signs in after another dismissed the notice never sees it; reproduced in the port.

export default {
  name: "AwaitingPaymentNotice",
  props: {
    orders: { type: Array, default: () => [] },
  },
  data() {
    return {
      PAYMENT_FAILED_STATUS,
      dismissed: dismissedThisSession,
    };
  },
  computed: {
    isVisible() {
      return !this.dismissed && this.orders.length > 0;
    },
  },
  methods: {
    dismiss() {
      dismissedThisSession = true;
      this.dismissed = true;
    },
  },
};
</script>

<style scoped>
.awaiting-payment-notice .close {
  position: absolute;
  top: 6px;
  right: 10px;
}

.awaiting-payment-notice__orders {
  list-style: none;
  padding: 0 24px 0 0;
  margin: 0;
}

.awaiting-payment-notice__orders li {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 0;
}
</style>
